function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter, getDefaultElementSize } from '@bydesign-ui/hooks';
import { AxisType } from '../enum';
import { Axis } from './Axis';
import { Point } from './Point';
export var Region = function (_Emitter) {
  _inherits(Region, _Emitter);

  var _super = _createSuper(Region);

  function Region(isSlider) {
    var _this;

    _classCallCheck(this, Region);

    _this = _super.call(this);
    _this.axisMap = {};
    _this.pointMap = {};
    _this.size = getDefaultElementSize();
    _this.dragging = false;

    _this.createAxis(AxisType.HORIZONTAL, !!isSlider);

    _this.createAxis(AxisType.VERTICAL, !!isSlider);

    return _this;
  }

  _createClass(Region, [{
    key: "repaint",
    value: function repaint() {
      this.emit('repaint');
    }
  }, {
    key: "getPoint",
    value: function getPoint(part) {
      if (!this.pointMap[part]) {
        throw new Error("Point ".concat(part, " is not found"));
      }

      return this.pointMap[part];
    }
  }, {
    key: "getAxis",
    value: function getAxis(type) {
      if (!this.axisMap[type]) {
        throw new Error("Axis ".concat(type, " is not found"));
      }

      return this.axisMap[type];
    }
  }, {
    key: "getAxisLength",
    value: function getAxisLength(type) {
      return type === AxisType.HORIZONTAL ? this.size.width : this.size.height;
    }
  }, {
    key: "updateRegionSize",
    value: function updateRegionSize(size) {
      var old = this.size;
      this.size = size;
      var xChanged = false;
      var yChanged = false;

      if (this.axisMap[AxisType.HORIZONTAL] && old.width !== size.width) {
        this.getAxis(AxisType.HORIZONTAL).repaint();
        xChanged = true;
      }

      if (this.axisMap[AxisType.VERTICAL] && old.height !== size.height) {
        this.getAxis(AxisType.VERTICAL).repaint();
        yChanged = true;
      }

      if (xChanged || yChanged) {
        this.repaintPoint();
      }

      this.repaint();
    }
  }, {
    key: "getDragging",
    value: function getDragging() {
      return this.dragging;
    }
  }, {
    key: "setDragging",
    value: function setDragging(dragging) {
      if (this.dragging !== dragging) {
        this.dragging = dragging;

        if (!dragging) {
          this.repaintPoint();
        }
      }
    }
  }, {
    key: "createAxis",
    value: function createAxis(type, isSlider) {
      if (this.axisMap[type]) {
        throw new Error("Axis ".concat(type, " has already exist"));
      }

      return this.axisMap[type] = new Axis(this, type, isSlider);
    }
  }, {
    key: "createPoint",
    value: function createPoint(part, type) {
      if (this.pointMap[part]) {
        throw new Error("Point ".concat(part, " has already exist"));
      }

      return this.pointMap[part] = new Point(this, type, part);
    }
  }, {
    key: "repaintPoint",
    value: function repaintPoint() {
      var _this2 = this;

      Object.keys(this.pointMap).forEach(function (key) {
        return _this2.getPoint(key).updatePointValue();
      });
    }
  }]);

  return Region;
}(Emitter);